/*
 * @Author: cn1994
 * @Date: 2023-12-19 11:13:44
 * @LastEditors: cn1994
 * @LastEditTime: 2025-04-16 10:25:15
 * @Description: file content
 */
// app3.0 路由
const routes = [
  // app个性化内跳转
  {
    path: '/appDecoration/readMaterials',
    name: 'appDecoration/readMaterials',
    meta:{
      title: "模块管理"
    },
    component: () => import('../pages/textbook/read/read.vue'),
  },
  // app个性化内跳转-书籍账号非主服务器专用
  {
    path: '/appDecoration/readMaterials_shuji',
    name: 'appDecoration/readMaterials_shuji',
    meta:{
      title: "模块管理"
    },
    component: () => import('../pages/textbook/shujiRead/read.vue'),
  },
  // 阅读区内跳转
  {
    path: '/readPlate/readMaterials',
    name: 'readPlate/readMaterials',
    meta:{
      title: "模块管理"
    },
    component: () => import('../pages/textbook/read/read.vue'),
  },
  // 制作视频配音课件
  {
    path: '/readPlate/createVideoDubbing',
    name: 'readPlate/createVideoDubbing',
    meta: { title: "制作视频配音" },
    component: () => import('../pages/createVideoDubbing/editBook.vue'),
  },
  //精选课程
  {
    path: '/learning/readMaterials',
    name: 'learning/readMaterials',
    meta:{
      title: "精选课程"
    },
    component: () => import('../pages/textbook/read/read.vue'),
  },
  //新版本机构
  {
    path: '/appDecoration',
    name: 'appDecoration',
    meta: {
      title: 'APP装修',
      volcengine: true,
    },
    component: () => import('../pages/appDecoration/appDecoration.vue')
  },
  // 阅读区教材
  {
    path: '/sectionCustom/readMaterials',
    name: 'sectionCustom/readMaterials',
    meta:{
      title: "模块管理"
    },
    component: () => import('../pages/textbook/read/read.vue'),
  },
];
export default routes;